module.exports = __webpack_public_path__ + "img/icon-Planner.a73e1511.png";